import { render, staticRenderFns } from "./BusinessScopeClient.vue?vue&type=template&id=67ebd3fc&"
import script from "./BusinessScopeClient.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports